import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
export const Loading = () => (React.createElement("div", { className: 'pageContainer loader', style: { alignItems: 'center' } },
    React.createElement(ThreeDots, { color: '#ffffff', height: 120, width: 120 })));
export default Loading;
